<template>
  <!-- 工作流明细导入弹窗 -->
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="uploading"
    @cancel="handleCancel"
    @ok="handleUpload"
  >
    <!-- 上传加载状态 -->
    <a-spin tip="上传中..." :spinning="uploading">
      <!-- 文件拖拽上传区域 -->
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <!-- 上传图标 -->
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <!-- 上传提示文字 -->
        <p class="ant-upload-text">请将工作流明细文件拖拽到此处上传</p>
        <!-- 上传说明 -->
        <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
      </a-upload-dragger>
      <!-- 下载模板链接 -->
      <!-- <a
        @click="handleTemplate"
        v-hasPermi="['system:wristband:importWorkflowTemplate']"
        >下载模板</a
      > -->
    </a-spin>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 工作流明细导入Excel组件
 * 功能：提供工作流明细数据的Excel文件导入功能
 * - 支持拖拽上传或点击选择文件
 * - 导入前校验手环ID
 * - 导入成功后刷新列表
 */
import { importWristbandWorkflowData } from '@/api/system/wristbandWorkflow'

export default {
  name: 'WorkflowImport',
  data() {
    return {
      title: '工作流明细导入', // 弹窗标题
      open: false, // 弹窗显示/隐藏状态
      fileList: [], // 文件列表（用于显示已选择的文件）
      uploading: false, // 上传中状态标识
      updateSupport: 0, // 是否支持更新（0-不支持，1-支持）
      wristbandId: null, // 手环ID
    }
  },
  methods: {
    /**
     * 取消导入操作
     * 关闭弹窗并清空文件列表，触发ok事件通知父组件
     */
    handleCancel() {
      this.open = false
      this.fileList = []
      $emit(this, 'ok')
    },
    /**
     * 打开导入弹窗
     * 供父组件调用，显示导入弹窗
     * @param {Number} wristbandId - 手环ID
     */
    importExcelHandleOpen(wristbandId) {
      if (!wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      this.wristbandId = wristbandId
      this.open = true
    },
    /**
     * 文件上传前的处理
     * 将选择的文件保存到fileList，返回false阻止自动上传（由手动点击确定按钮触发上传）
     * @param {File} file - 选择的文件对象
     * @returns {Boolean} false - 阻止自动上传
     */
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    /**
     * 确认上传工作流明细数据
     * 校验文件选择和手环ID，构建FormData并调用导入接口
     */
    handleUpload() {
      // 1. 检查是否选择了文件
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.warning('请先选择要导入的文件', 3)
        return
      }
      // 2. 检查手环ID
      if (!this.wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      // 3. 开始上传，显示加载状态
      this.uploading = true
      // 4. 构建FormData表单数据
      const formData = new FormData()
      formData.append('file', this.fileList[0]) // 上传的文件
      formData.append('updateSupport', this.updateSupport) // 是否支持更新
      formData.append('wristbandId', this.wristbandId) // 手环ID（必填）
      // 5. 调用导入接口
      importWristbandWorkflowData(formData)
        .then((response) => {
          // 导入成功（code为20001表示成功）
          if (response.code == 20001) {
            this.$message.success(
              response.message || response.data || '导入成功'
            )
            this.open = false
            this.fileList = []
            // 触发ok事件，通知父组件刷新列表
            $emit(this, 'ok')
          } else {
            // 导入失败，显示错误信息
            this.$message.error(response.message || '导入失败')
          }
        })
        .catch(() => {
          // 请求异常，显示错误提示
          this.$message.error('导入失败，请稍后重试')
        })
        .finally(() => {
          // 无论成功或失败，都要关闭上传状态
          this.uploading = false
        })
    },
    /**
     * 移除文件
     * 清空文件列表并重置上传状态
     */
    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
  },
  emits: ['ok'],
}
</script>
